/**
 * The subscription overhaul has shipped, so this is on for everyone. It no
 * longer reads REACT_APP_SUBSCRIPTION_OVERHAUL or the internal-email check.
 *
 * Kept as a hook rather than deleted because roughly forty call sites still
 * branch on it. Returning a constant makes those branches dead without touching
 * them, so they can be unwound in their own pass rather than riding along with
 * unrelated work.
 */
export const useShouldShowSubscriptionOverhaul = (): boolean => true;
